// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import Vue from "vue";
import store from "./store";
import axios from "axios";
import md5 from "js-md5";
import UmyUi from "umy-ui";
import "umy-ui/lib/theme-chalk/index.css"; // 引入样式
// import "./assets/theme/index.css";.
import App from "./App";
import router from "./router";
import "@/assets/css/style.css";
import { includeimg, allsum, colWidth } from "@/assets/js/index";

import "./permission";

// 全局指令 — 防重复点击
import clickLock from "@/directives/clickLock";
import debounceClick from "@/directives/debounceClick";
Vue.directive("click-lock", clickLock);
Vue.directive("debounce-click", debounceClick);

Vue.config.productionTip = false;
Vue.prototype.$md5 = md5;
Vue.prototype.includeimg = includeimg;
Vue.prototype.allsum = allsum;
Vue.prototype.$colWidth = colWidth;
Vue.use(UmyUi);
Vue.use(ElementUI);
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  axios,
  components: { App },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js